/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaBooster = {
    properties: {
        name: {
            type: 'Translation',
            isRequired: true,
        },
        description: {
            type: 'Translation',
            isRequired: true,
        },
        boosterType: {
            type: 'FantaBoosterType',
            isRequired: true,
        },
        emblem: {
            type: 'Image',
            isRequired: true,
        },
    },
} as const;
